module.exports = __webpack_public_path__ + "img/item-3.8be14f2.png";